// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { put, takeEvery } from 'redux-saga/effects';
import {
    actionStatusFailed,
    actionStatusStarted,
    actionStatusSuccess,
} from './../../../store/actionStatus';

import {
    RESET_SELECTED_SHIPPING_OFFER_DATA,
    GET_SELECTED_SHIPPING_OFFER_DATA,
    resetSelectedShippingOfferData,
    resetSelectedShippingOfferDataSuccess,
    getSelectedShippingOfferData,
    getSelectedShippingOfferDataSuccess,
} from './../../../store/orderCreation';

function* getSelectedShippingAddress(request: any): IterableIterator<any> {
    try {
        yield put(
            actionStatusStarted({
                actionName: GET_SELECTED_SHIPPING_OFFER_DATA,
            })
        );

        yield put(getSelectedShippingOfferDataSuccess(request.payload));

        yield put(
            actionStatusSuccess({
                actionName: GET_SELECTED_SHIPPING_OFFER_DATA,
            })
        );
    } catch (e) {
        yield put(
            actionStatusFailed({
                actionName: GET_SELECTED_SHIPPING_OFFER_DATA,
                error: e,
            })
        );
    }
}

function* getResetSelectedShippingAddress(request: any): IterableIterator<any> {
    try {
        yield put(
            actionStatusStarted({
                actionName: RESET_SELECTED_SHIPPING_OFFER_DATA,
            })
        );

        yield put(resetSelectedShippingOfferDataSuccess());

        yield put(
            actionStatusSuccess({
                actionName: RESET_SELECTED_SHIPPING_OFFER_DATA,
            })
        );
    } catch (e) {
        yield put(
            actionStatusFailed({
                actionName: RESET_SELECTED_SHIPPING_OFFER_DATA,
                error: e,
            })
        );
    }
}

export default [
    takeEvery(`${getSelectedShippingOfferData}`, getSelectedShippingAddress),
    takeEvery(
        `${resetSelectedShippingOfferData}`,
        getResetSelectedShippingAddress
    ),
];
